export class FlagManager {
  constructor(flags, options) {
    this.flags = flags || {};
    this.callbacks = {};
    this.debounceTimeouts = {};
    this.options = options || {};
  }
  clearTimeout(flag) {
    let timeout = this.debounceTimeouts[flag];
    if (timeout != null) clearTimeout(timeout);
  }
  debounceSet(flag, state, debounceTime) {
    this.clearTimeout(flag);
    let timeout = setTimeout(() => this.set(flag, state), debounceTime);
    this.debounceTimeouts[flag] = timeout;
  }
  get(flag) {
    return this.flags[flag];
  }
  notifyFlagChange(flag, callback) {
    let state = this.flags[flag];
    if (callback) {
      callback(state);
    } else {
      let callbacks = this.callbacks[flag] || [];
      callbacks.forEach((callback) => callback(state));
    }
  }
  onChange(flag, callback) {
    if (!this.callbacks[flag]) this.callbacks[flag] = [];
    if (!this.callbacks[flag].includes(callback)) this.callbacks[flag].push(callback);
    this.notifyFlagChange(flag, callback);
    return callback;
  }
  offChange(flag, callback) {
    let i = this.callbacks[flag].indexOf(callback);
    if (i != -1) this.callbacks[flag].splice(i, 1);
    return callback;
  }
  set(flag, state) {
    this.clearTimeout(flag);
    if (this.flags[flag] != state) {
      this.flags[flag] = state;
      this.notifyFlagChange(flag);
    }
  }
}
